<template>
  <div>
    <b-modal id="modal-input-jadwal-lengkap" size="xl" centered scrollable title="Input Jadwal" header-bg-variant="primary" header-text-variant="light" @show="showModal()" @hide="reset()">
      <CRow>
        <!-- LEFT SIDE (Karyawan) -->
        <CCol col="6">
          <div class="mx-2">
            <!-- Cabang Selector -->
            <b-form-group label="" label-for="cabang">
              <Multiselect
                id="cabang"
                class="m-0 p-0 w-100"
                style="white-space: nowrap"
                v-model="filter.cabang"
                :options="listCabang"
                :multiple="false"
                :searchable="true"
                :close-on-select="true"
                label="namaCabang"
                track-by="cabangId"
                placeholder="cabang"
                size="sm"
              />
            </b-form-group>

            <!-- Employee Groups -->
            <div class="employee-section mb-3" v-for="(x, key) of listKaryawan" :key="key">
              <div class="d-flex justify-content-between align-items-center mb-2 section-header">
                <h5 class="fw-bold m-0"><i class="fas fa-users me-2 text-primary"></i> {{ key }}</h5>
                <b-button size="sm" variant="outline-success" @click="toggleAll(key)"> Pilih Semua </b-button>
              </div>
              <div class="employee-list">
                <b-form-checkbox v-for="(y, i) of x.list" :key="i" v-model="x.list[i].select" @change="selectKaryawan(key, i)">
                  {{ y.namaKaryawan }}
                </b-form-checkbox>
              </div>
            </div>
          </div>
        </CCol>

        <!-- RIGHT SIDE (Shift) -->
        <CCol col="6">
          <b-form-group label="Tanggal mulai" label-for="tglAwal">
            <DatePicker id="tglAwal" style="width: 100%" format="dddd, DD MMMM YYYY" v-model="data.tglAwal" @input="data.tglAkhir = data.tglAwal" />
          </b-form-group>

          <b-form-group label="Tanggal akhir" label-for="tglAkhir">
            <DatePicker id="tglAkhir" style="width: 100%" format="dddd, DD MMMM YYYY" v-model="data.tglAkhir" />
          </b-form-group>

          <b-form-group label="" label-for="hari">
            <Multiselect
              id="hari"
              class="m-0 p-0 w-100"
              v-model="data.pengecualianHari"
              :options="listHari"
              :multiple="true"
              :searchable="true"
              :close-on-select="true"
              placeholder="hari libur"
              size="sm"
            />
          </b-form-group>

          <p>{{ $moment($moment(data.tglAkhir).format("YYYY-MM-DD")).diff($moment(data.tglAwal).format("YYYY-MM-DD"), "Days") + 1 }} hari</p>

          <p class="text-center shift-label">Shift</p>

          <b-row class="overflow-auto mx-0" style="max-height: 40vh">
            <b-col cols="12" class="pl-0 pr-1" v-for="(item, key) in listShift" :key="key">
              <b-card class="mb-3 shift-card" :class="{ active: data.shift === item }" @click="toggleShift(item)">
                <div class="d-flex justify-content-between align-items-center">
                  <!-- Left -->
                  <div>
                    <h6 v-if="item.masterShiftId" class="mb-1 text-muted branch-name">
                      {{ item.namaCabang }}
                    </h6>
                    <h5 class="mb-0 shift-title">
                      <span v-if="item.masterShiftId" class="shift-category">{{ item.kategoriShift }} - </span>
                      <span class="shift-name">{{ item.namaShift }}</span>
                    </h5>
                  </div>
                  <!-- Right -->
                  <div v-if="item.masterShiftId" class="text-right">
                    <p class="mb-1 shift-time"><i class="fas fa-clock text-primary"></i> {{ item.namaJamKerja }}</p>
                    <p class="mb-0 shift-pay"><i class="fas fa-coins text-warning"></i> {{ item.namaNominalUpah }}</p>
                  </div>
                </div>
              </b-card>
            </b-col>
          </b-row>
        </CCol>
      </CRow>

      <!-- Footer -->
      <template #modal-footer>
        <b-button variant="success" class="px-4" @click="convertKaryawan(), $bvModal.show('modal-pilih-data-input-lengkap')"> <i class="fas fa-check-circle"></i> Simpan </b-button>
        <b-button variant="warning" class="px-4" @click="reset()"> <i class="fas fa-undo"></i> Reset </b-button>
        <b-button variant="secondary" class="px-4" @click="$bvModal.hide('modal-input-jadwal-lengkap')"> <i class="fas fa-times"></i> Tutup </b-button>
      </template>
    </b-modal>
  </div>
</template>

<script>
export default {
  name: "modalInputJadwalLengkap",
  props: ["filter", "listCabang"],
  data() {
    return {
      busy: false,
      listKaryawan: {},
      listKaryawanRegister: {},
      listShift: {},
      listHari: ["Senin", "Selasa", "Rabu", "Kamis", "Jumat", "Sabtu", "Minggu"],
      data: {
        tglAwal: null,
        tglAkhir: null,
        shift: {},
        pengecualianHari: [],
      },
      alertKaryawan: [],
    };
  },
  computed: {
    // data(){
    //   return {
    //     tglAwal: null,
    //     tglAkhir: null,
    //   }
    // },
  },
  watch: {
    "filter.cabang"(newVar, oldVar) {
      if (newVar != oldVar) {
        this.getDataShift();
        this.getKaryawan();
      }
    },
  },
  async mounted() {
    const vm = this;
    vm.reset();
    vm.getKaryawan();
    vm.getDataShift();
  },
  methods: {
    async showModal() {},
    toggleAll(key) {
      const vm = this;
      let allSelected = vm.listKaryawan[key].list.every((x) => x.select);
      vm.listKaryawan[key].list.forEach((x) => (x.select = !allSelected));
      vm.listKaryawan[key].select = !allSelected;
    },

    selectKaryawan(key) {
      const vm = this;
      let allChecked = vm.listKaryawan[key].list.every((x) => x.select);
      vm.listKaryawan[key].select = allChecked;
    },
    selectPosisi(key) {
      const vm = this;
      for (let i = 0; i < vm.listKaryawan[key].list.length; i++) {
        const x = vm.listKaryawan[key].list[i];
        x.select = vm.listKaryawan[key].select;
      }
    },
    // selectKaryawan(key, index) {
    //   const vm = this;
    //   let select = false;
    //   if (vm.listKaryawan[key].list[index].select) {
    //     let cek = 0;
    //     for (let i = 0; i < vm.listKaryawan[key].list.length; i++) {
    //       const x = vm.listKaryawan[key].list[i];
    //       if (x.select) cek++;
    //     }
    //     if (cek == vm.listKaryawan[key].list.length) select = true;
    //   }
    //   vm.listKaryawan[key].select = select;
    // },
    convertKaryawan() {
      const vm = this;
      vm.listKaryawanRegister = [];
      for (const key in vm.listKaryawan) {
        for (let i = 0; i < vm.listKaryawan[key].list.length; i++) {
          const x = vm.listKaryawan[key].list[i];
          if (x.select) vm.listKaryawanRegister.push(x);
        }
      }
      vm.simpan();
    },
    async getKaryawan() {
      const vm = this;
      const listKaryawan = await vm.$axios.post("dataKaryawan/list", {
        cabangId: vm.filter.cabang ? vm.filter.cabang.cabangId : null,
      });
      // console.log('listKaryawan', listKaryawan)
      if (listKaryawan.data.status == 200) {
        const karyawan = {};
        for (let i = 0; i < listKaryawan.data.data.length; i++) {
          const x = listKaryawan.data.data[i];
          x.select = false;
          let cek = true;
          for (const y in karyawan) {
            if (x.namaPosisi === y) {
              karyawan[y].list.push(x);
              cek = false;
              break;
            }
          }
          if (cek) {
            karyawan[x.namaPosisi] = {
              list: [x],
              select: false,
            };
          }
        }
        vm.listKaryawan = karyawan;
      }
    },
    async getDataShift() {
      const vm = this;
      vm.tableBusy = true;
      const listShift = await vm.$axios.post("masterShift/list", {
        cabangId: vm.filter.cabang ? vm.filter.cabang.cabangId : null,
      });
      if (listShift.data.status == 200) {
        vm.listShift = [];
        listShift.data.data.push({
          masterShiftId: null,
          namaCabang: "",
          namaShift: "Day Off",
          namaJamKerja: "",
          namaNominalUpah: "",
          warna: "#CED2D8",
        });
        for (let i = 0; i < listShift.data.data.length; i++) {
          const x = listShift.data.data[i];
          if (vm.dataShift && x.masterShiftId == vm.dataShift.masterShiftId) {
            x.disabled = true;
          }
          vm.listShift.push({
            ...x,
            namaJamKerja: vm.$moment(x.jamMasuk, "HH:mm:ss").format("HH:mm") + " - " + vm.$moment(x.jamKeluar, "HH:mm:ss").format("HH:mm"),
            namaNominalUpah: vm.$numberFormat(x.nominalUpah, "idr"),
          });
        }
      }
      vm.totalRows = vm.listShift.length;
    },
    async simpan() {
      const vm = this;
      // vm.$emit("triggerAlert", {
      //   variant: "success",
      //   msg: "register jadwal lengkap belum dibuat",
      //   show: true,
      // });
      const simpan = await vm.$axios.post("masterShift/registerJadwalBulk", {
        // ...vm.data,
        pengecualianHari: vm.data.pengecualianHari,
        bulkDataKaryawan: vm.listKaryawanRegister,
        masterShiftId: vm.data.shift ? vm.data.shift.masterShiftId : null,
        cabangId: vm.data.shift ? vm.data.shift.cabangId : null,
        tglAwal: vm.$moment(vm.data.tglAwal).format("YYYY-MM-DD"),
        tglAkhir: vm.$moment(vm.data.tglAkhir).format("YYYY-MM-DD"),
      });
      // console.log("simpan", simpan);
      vm.$bvModal.hide("modal-pilih-data-input-lengkap");
      if (simpan.data.status == 200) {
        vm.reset();
        vm.$bvModal.hide("modal-input-jadwal-lengkap");
        vm.$emit("triggerAlert", {
          variant: "success",
          msg: "BERHASIL MENAMBAH JADWAL".toUpperCase(),
          show: true,
        });
      } else {
        vm.$bvModal.show("modal-alert-input-lengkap");
        // vm.alertKaryawan = simpan.data.data
        vm.alertKaryawan = simpan.data.data.sort((a, b) => (a.namaKaryawan > b.namaKaryawan ? 1 : b.namaKaryawan > a.namaKaryawan ? -1 : 0));
        vm.$emit("triggerAlert", {
          variant: "danger",
          msg: simpan.data.message,
          show: true,
        });
      }
    },
    toggleShift(item) {
      if (this.data.shift === item) {
        this.data.shift = null; // batal pilih
      } else {
        this.data.shift = item;
      }
    },
    reset() {
      const vm = this;
      for (const key in vm.listKaryawan) {
        vm.listKaryawan[key].select = false;
        for (let i = 0; i < vm.listKaryawan[key].list.length; i++) {
          vm.listKaryawan[key].list[i].select = false;
        }
      }
      vm.data.tglAwal = new Date();
      vm.data.tglAkhir = new Date();
      vm.data.shift = {};
      vm.data.pengecualianHari = null;
      vm.listKaryawanRegister = [];
      vm.filter.cabang = null;
    },
  },
};
</script>

<style scoped>
/* width */
::-webkit-scrollbar {
  margin: 0px;
  width: 2px;
}

/* Track */
::-webkit-scrollbar-track {
  background: #f1f1f1;
}

/* Handle */
::-webkit-scrollbar-thumb {
  background: #02a433;
}

/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
  background: #555;
}

.shift-card {
  border: 1px solid #e0e0e0;
  border-radius: 12px;
  cursor: pointer;
  transition: all 0.2s ease-in-out;
  padding: 12px 16px;
}

.shift-card:hover {
  border-color: #28a745; /* Bootstrap success */
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
}

.shift-card.active {
  border-color: #28a745;
  background-color: #f8fff9;
}

.branch-name {
  font-size: 14px;
  font-weight: 500;
  color: #6c757d;
}

.shift-title {
  font-size: 16px;
  font-weight: 500;
  color: #333;
}

.shift-category {
  font-size: 15px;
  font-weight: 400;
  color: #7c7c7c;
  margin-right: 4px;
}

.shift-name {
  font-size: 16px;
  font-weight: 600;
  color: #28a745;
}

.shift-time {
  font-size: 15px;
  font-weight: 500;
  color: #444;
}

.shift-pay {
  font-size: 14px;
  font-weight: 500;
  color: #666;
}

.employee-section {
  border: 1px solid #eaeaea;
  border-radius: 10px;
  padding: 12px;
  background: #fafafa;
}
.section-header {
  border-bottom: 1px solid #ddd;
  padding-bottom: 5px;
}
.employee-list {
  max-height: 180px;
  overflow-y: auto;
  padding-left: 10px;
}
.shift-label {
  font-size: 20px;
  font-weight: 600;
  color: #7c7c7c;
  margin: 10px 0;
}
.shift-card {
  border: 1px solid #ddd;
  border-radius: 12px;
  transition: all 0.3s;
  cursor: pointer;
}
.shift-card:hover {
  border-color: #28a745;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.05);
}
.shift-card.active {
  border-color: #28a745;
  background: #f0fff4;
  box-shadow: 0 4px 12px rgba(0, 128, 0, 0.2);
}
</style>
